module.exports = __webpack_public_path__ + "img/pm.d208497e.png";